import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Auth, Storage } from 'aws-amplify';
import API_REST from '../../../api-rest-uruk';
import AlertDialog from '../../UI/AlertDialog';
import { useParams } from 'react-router-dom';
import { makeStyles, Paper } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import LoadingCard from '../../UI/LoadingCard';
import { connect } from 'react-redux';
import UploadForm from '../../UploadForm';

const useStyles = makeStyles(theme => ({
  paper: {
    maxWidth: '50%',
    margin: 'auto',
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    },
    [theme.breakpoints.down(600 + theme.spacing(6))]: {
      maxWidth: '100%'
    }
  }
}));

const UploadXLS = (props) => {
  const { subgroup } = props;

  const classes = useStyles();
  const { t } = useTranslation();
  let { bundleId } = useParams();
  const [message, setMessage] = useState('');
  const [files, setFiles] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const FILE_TYPES_ACCEPTED = ['.xlsx'];

  const checkFileExtension = () => {
    const file = files[0];
    const ext = /[.]\w{3,4}$/.exec(file.name)[0];

    if (!ext || !FILE_TYPES_ACCEPTED.includes(ext)) {
      const error = new Error('Wrong Extension');
      error.customMessage = `${t('bundleUpdate:extensionError')} ${FILE_TYPES_ACCEPTED}`;
      return error;
    }

    return null;
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      e.persist();
      setLoading(true);
      setMessage(t('bundleUploadView:uploading'));

      const error = checkFileExtension();

      if (error) {
        setLoading(false);
        setMessage('');
        throw error;
      }

      let input = {};
      const user = await Auth.currentAuthenticatedUser();
      const currentUserEmail = user.signInUserSession.idToken.payload.email;
      const file = files[0];
      const timestamp = Date.now();
      const id = `${timestamp}_${bundleId}`;
      const ext = /[.]\w{3,4}$/.exec(file.name)[0];
      input.fileUrl = `bundle/${subgroup}/${bundleId}/${id}${ext}`;
      input.bundleId = bundleId;
      input.currentUserEmail = currentUserEmail;

      await Storage.put(`${input.fileUrl}`, file, { contentType: file.type });
      await API_REST.generateDocs(input).then(() => {
        setLoading(false);
        setMessage(t('bundleUploadView:success'));
        props.history.push('/bundle');
      });
    } catch (e) {
      console.error(e);
      let errorMessage;
      let variables = {};
      if (e.response && e.response.data) {
        errorMessage = e.response.data.message;
        variables = e.response.data.variables;
      }
      setLoading(false);
      setMessage('');
      setError(t(errorMessage || e.customMessage || 'bundleUploadView:genericError', variables));
    }
  };

  return (
    <Paper className={classes.paper}>
      <LoadingCard open={loading} loading={loading} message={message} />
      <AlertDialog open={!!error} title='Error' description={error} setOpen={() => setError(null)} />
      <UploadForm
        newDocument
        handleSubmit={handleSubmit}
        handleCancel={props.history.goBack}
        setContent={setFiles}
        accept={FILE_TYPES_ACCEPTED.join(',')}
        title={t('bundleUploadView:title')}
        nameLabel={t('bundleUploadView:xlsxName')}
        descriptionLabel={t('bundleUploadView:xlsxDescription')}
        actionButtonLabel={t('bundleUploadView:title')}
      />
    </Paper>
  );
};

UploadXLS.propTypes = {
  history: PropTypes.object.isRequired,
  subgroup: PropTypes.string.isRequired
};
const mapStateToProps = (state) => {
  return {
    subgroup: state.config.subgroup
  };
};

export default connect(mapStateToProps, null)(UploadXLS);
